import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, isDevMode, LOCALE_ID } from '@angular/core';
import { ExtraOptions, PreloadAllModules } from '@angular/router';
import { AppComponent } from './app.component';
import { DatePipe } from '@angular/common';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { UserDeviceInterceptor } from './interceptors/user-device.interceptor';
//module from firebase
import { AngularFireModule } from '@angular/fire/compat';
import { ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { AngularFireAnalytics, CONFIG, COLLECTION_ENABLED } from "@angular/fire/compat/analytics";
// Local imports
import { environment } from '../environments/environment';
import { APP_ROUTING } from './app-routing.module';
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { SharedModule } from './shared/shared.module';
import { CookieBannerComponent } from './shared/cookie-banner/cookie-banner.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { LottieModule } from 'ngx-lottie';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';

registerLocaleData(localeEs, 'es');

export function playerFactory() {
  return import('lottie-web');
}

const routerConfig: ExtraOptions = {
  preloadingStrategy: PreloadAllModules,
  scrollPositionRestoration: 'enabled'
};

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    SharedModule,
    // Standalone, so it is imported rather than declared.
    CookieBannerComponent,
    BrowserAnimationsModule,
    APP_ROUTING,
    AngularFireModule.initializeApp(environment.firebase),
    // `AngularFireAnalyticsModule` stays out: importing it injects gtag.js before consent.
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http:HttpClient) => { return new TranslateHttpLoader(http, './assets/i18n/', '.json'); },
        deps: [HttpClient]
      }
    }),
    LottieModule.forRoot({ player: playerFactory }),
    RecaptchaV3Module,
  ],
  providers: [
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha.siteKey },
    { provide: LOCALE_ID, useValue: 'es' },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    // Attaches the X-User-Device-* headers to apiUrl requests only.
    { provide: HTTP_INTERCEPTORS, useClass: UserDeviceInterceptor, multi: true },
    DatePipe,
    AngularFireAnalytics,
    // Inert, and left that way, for two independent reasons: these are the *modular* services
    // (`@angular/fire/analytics`) while the compat ones are what would be injected, and the only
    // thing that injects them is the `AngularFireAnalyticsModule` constructor, which is kept out of
    // `imports` above. Switching automatic screen/user tracking on would therefore take both the
    // compat classes *and* something to construct them — a consent decision, not a wiring fix.
    // Nothing depends on the user-tracking half: `AnalyticsService` derives the uid from auth state.
    ScreenTrackingService,
    UserTrackingService,
    { provide: CONFIG, useValue: {
      allow_ad_personalization_signals: false,
      anonymize_ip: true
      }
    },
    // Belt and braces beside the lazy loading above: even once the SDK is up, it collects nothing
    // until `TrackingLoaderService` enables it.
    { provide: COLLECTION_ENABLED, useValue: false }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
